import { loadableWithFallback } from '@vision/ui/utils';
import type { CatiChart1Props } from './CatiChart1';

export const CatiChart1 = loadableWithFallback<CatiChart1Props>(() => import('./CatiChart1'));
